// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sandygast: PokeData = {
  "id": 769,
  "name": "sandygast",
  "height": 5,
  "weight": 700,
  "base_experience": 64,
  "types": [
    PokeType.GHOST,
    PokeType.GROUND
  ],
  "api_moves": [
    "sand-attack",
    "absorb",
    "mega-drain",
    "hypnosis",
    "harden",
    "sandstorm",
    "giga-drain",
    "shadow-ball",
    "astonish",
    "sand-tomb",
    "iron-defense",
    "earth-power",
    "bulldoze",
    "shore-up"
  ],
  "moves": [
    "sandstorm",
    "shadow-ball",
    "earth-power",
    "shadow-dagger",
    "night-shade",
    "confuse-ray",
    "rototiller",
    "mud-shot",
    "earthquake",
    "mud-bomb",
    "soul-sacrifice",
    "shadow-sneak",
    "fissure"
  ],
  "evolution_chain": {
    "id": 397,
    "item": null,
    "species": [
      {
        "name": "sandygast",
        "order": 769,
        "types": [
          PokeType.GHOST,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "palossand",
        "order": 770,
        "types": [
          PokeType.GHOST,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 769,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 42,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 58.75,
    "speed": 15,
    "ability_power": 70
  },
  "stat_changes": [],
  "catch_rate": 140,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
